import { Tabs } from "antd";
import { useAppSelector } from "../../redux/hooks.ts";
import { getFolderExtraInfoTabs } from "./fixtures/getFolderExtraInfoTabs.tsx";
import { useIsMobile } from "../../hooks/useIsMobile.ts";

export const CardExtraInfo: React.FC = () => {
  const { activeFolder: folder } = useAppSelector((state) => state.folder);
  const { isMobile } = useIsMobile();

  if (!folder?.subfolders) return null;

  const folderItemTabs = getFolderExtraInfoTabs(
    folder.subfolders,
    !!folder.collaborator,
  );

  return (
    <div>
      <Tabs defaultActiveKey="1" centered={!isMobile} items={folderItemTabs} />
    </div>
  );
};
